export const activity = {
  activityWebEmptyStateTitle: 'No activity yet',
  activityWebEmptyStateText: 'Here will be your notifications feed',
  activitySeeAll: 'See all',
  in: 'in'
}
